import { render } from "./MSFOReportsPage.vue?vue&type=template&id=ac8a97e6"
import script from "./MSFOReportsPage.vue?vue&type=script&lang=js"
export * from "./MSFOReportsPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__